import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCliente} from '../../../redux/actions/dataactions';
import { getActivo, getMtoCorrActivo } from '../../../redux/actions/mobiliarioactions';
import { PDFViewer } from '@react-pdf/renderer';
import './ReporteCorrPDFActivo.css';
import ReporteCorrDocuPDFActivo from './ReporteCorrDocuPDFActivo';

const ReporteCorrPDFActivo = ({ getActivo, getCliente, getMtoCorrActivo, data, dataMob, match }) => {
  const [verPDF, setVerPDF] = useState(false);
  const history = useHistory();
  const { cliente, loading } = data;
  const {mobiliario,mtocorrectivomobiliario,loadingdata}=dataMob;

  useEffect(() => {
    // get MTO PREVENTIVO DEBE ENVIAR DESDE LA LISTA EL ID DEL REPORTE DE MTO TAMBIÉN
    getMtoCorrActivo(match.params.mtoid);
    // GET EQUIPO
    getActivo(match.params.mobiliarioId);
    // get cliente
    getCliente(match.params.clienteId);
  }, [getMtoCorrActivo, getActivo, getCliente, match.params.mtoid, match.params.activoId, match.params.clienteId]);

  const handleOpenPDF = () => {
    setVerPDF(!verPDF);
  };

  const goBack = () => {
    history.goBack(); // Esto llevará a la página anterior, independientemente de su origen.
  };

  const renderContent = () => {
    if (!cliente?.plantillaType) {
      return (
        <div className="mto-error-message">
          <p>Para ver las plantillas, primero debe configurar el tipo de plantilla en la lista de clientes</p>
        </div>
      );
    }

    if (mobiliario && cliente && verPDF) {
      return (
        <PDFViewer style={{ width: "100%", height: "90vh" }}>
          <ReporteCorrDocuPDFActivo 
            mobiliario={mobiliario} 
            cliente={cliente} 
            mtocorrectivo={mtocorrectivomobiliario} 
          />
        </PDFViewer>
      );
    }

    return null;
  };

  return (
    <div className='div-inventaripdfgeneral'>
      <div className='div-inventaripdftitulo'>
        <div className="div_boton">
          <MyButton tip="Volver" onClick={goBack}>
            <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
          </MyButton>
        </div>
        {cliente?.plantillaType && (
          <Button 
            variant="text"
            color="primary"
            onClick={handleOpenPDF}
          >
            {verPDF ? "Ocultar PDF" : "Ver PDF"}
          </Button>
        )}
      </div>
      <div className='div-inventariopdfcontent'>
        {renderContent()}
      </div>
    </div>
  );
}

ReporteCorrPDFActivo.propTypes = {
  getActivo: PropTypes.func.isRequired,
  getCliente: PropTypes.func.isRequired,
  getMtoCorrActivo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  dataMob:PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  data: state.data,
  dataMob:state.dataMob
})

export default connect(mapStateToProps, { getActivo, getCliente, getMtoCorrActivo })(ReporteCorrPDFActivo);